import type { ReactNode } from 'react';
import { cn } from '@/shared/lib';

export interface KbdProps {
  children: ReactNode;
  className?: string;
}

/** Подсказка клавиши (README §1: «/» 10 600 ink-400, border line-strong, radius 18, padding 1 5). */
export function Kbd({ children, className }: KbdProps) {
  return (
    <kbd
      className={cn(
        'rounded-18 border border-line-strong px-5 py-1 font-ui text-[10px] leading-none font-semibold text-ink-400',
        className,
      )}
    >
      {children}
    </kbd>
  );
}
